import React, {useState, useEffect} from 'react';
import {Grid, CircularProgress} from "@mui/material";
import {getScrapCategory, getScrapedNewsAPI} from "../../../apis/my_service";
import EmptyBookmark from "./EmptyBookmark";
import Bookmark from "./Bookmark";


const Categories = ({changeSensor}) => {
    const [loading, setLoading] = useState(true)
    const [bookmarkList, setBookmarkList] = useState([])
    const [bookmarkBox, setBookmarkBox] = useState([]);
    const [categoryBtnList, setCategoryBtnList] = useState([]) // 카테고리 버튼 목록

    useEffect(() => {
        getScrapCategory()
            .then(res => {
                if(!!res){
                    const newBtnList = res.map(list => ({...list, edit: false}))
                    setCategoryBtnList(newBtnList)
                }
            })
    }, [changeSensor])

    useEffect(() => {
        getScrapedNewsAPI()
            .then(res => {
                setLoading(false)
                setBookmarkList(res.reverse())
            })
    }, [])

    useEffect(() => {
        const filteredBookmarkList = bookmarkList
            .filter((bookmark) => bookmark.categoryid === '0')
            .map((bookmark) => ({...bookmark, checked: false}));
        setBookmarkBox(filteredBookmarkList);
    }, []);


    return (

            <Grid container spacing={2} justifyContent="center" alignItems="center" sx={{marginBottom:'100px'}}>
                {loading ? <CircularProgress color="inherit" />
                    :
                    bookmarkList.length === 0 ? <EmptyBookmark /> : <Bookmark categoryBtnList={categoryBtnList} bookmarkList={bookmarkList} />}
            </Grid>


    );
};

export default Categories;